import { defaultCaseDeatilsFormDetails } from '@constants/case-create';
import { SET_FORM_DATA, RESET_FORM_DATA } from '../actions/case-deatis-form-actions';

const initialState = {
  formData: defaultCaseDeatilsFormDetails,
};

const caseDetailsformReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
      };
      case 'RESET_FORM_DATA':
      return {
        ...state,
        formData: defaultCaseDeatilsFormDetails,
      };
    default:
      return state;
  }
};

export default caseDetailsformReducer;